import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

class AccounttypeController {
  constructor($http, $localStorage, $state, AuthService, SecurityService, $timeout) {
    this.name = "accounttype";
    $localStorage.activeStateName = "accounttype";

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.pages = [];
    this.currentUser = this.$auth.getUserData();

    var _this = this;
  }
}

AccounttypeController.$inject = ["$http", "$localStorage", "$state", "auth", "security", "$timeout"];

export default AccounttypeController;



// WEBPACK FOOTER //
// ./client/app/components/accounttype/accounttype.controller.js